import { render, staticRenderFns } from "./SharedCardTermsModal.vue?vue&type=template&id=15d6123e&"
import script from "./SharedCardTermsModal.vue?vue&type=script&lang=js&"
export * from "./SharedCardTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports